var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectArrowGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2625_343",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 14,
    height: 14,
    transform: "rotate(-90 0 14)",
    fill: "#A4A4A4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2625_343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.53461 8.41042L10.8221 4.12292C10.9679 3.97708 11.1381 3.9066 11.3325 3.91146C11.527 3.91632 11.6971 3.99167 11.8429 4.1375C11.9888 4.28333 12.0617 4.45347 12.0617 4.64792C12.0617 4.84236 11.9888 5.0125 11.8429 5.15833L7.36586 9.65C7.24919 9.76667 7.11794 9.85417 6.97211 9.9125C6.82628 9.97083 6.68044 10 6.53461 10C6.38878 10 6.24294 9.97083 6.09711 9.9125C5.95128 9.85417 5.82003 9.76667 5.70336 9.65L1.21169 5.15833C1.06586 5.0125 0.995374 4.83993 1.00024 4.64062C1.0051 4.44132 1.08044 4.26875 1.22628 4.12292C1.37211 3.97708 1.54225 3.90417 1.73669 3.90417C1.93114 3.90417 2.10128 3.97708 2.24711 4.12292L6.53461 8.41042Z",
    fill: "#A4A4A4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrowGray);
export default __webpack_public_path__ + "static/media/select-arrow-gray.20740c94c5fa4ac7b5cd061288ffbe48.svg";
export { ForwardRef as ReactComponent };